import React from "react";

import { UIBody } from "./Body";
import { UIColumn } from "./Column";
import { UITableHeader } from "./Header";

export type Column = {
  title: string;
  columnName: string;
  spacingColumns?: string;
  formatComponent?: (value: string, rowIndex?: number) => React.ReactChild;
};

interface Props {
  titleTable: string;
  checkField?: boolean;
  isOnViewMode?: boolean;
  columns: Column[];
  data: Array<any>;
  headerActions?: React.ReactChild;
  selectRow?: number[];
  isActionColumnOnEnd?: boolean;
  errors?: string;
  hasBodyErrors?: boolean;

  onSelectRowAll?: (checked: boolean) => void;
  onSelectRow?: (rowIndex: any) => void;
  actionColumn?: (value: number) => React.ReactChild;
}

const UITable = ({
  titleTable,
  checkField = true,
  isOnViewMode = false,
  hasBodyErrors = false,
  errors,
  headerActions,
  actionColumn,
  columns,
  data,
  selectRow,
  onSelectRowAll,
  onSelectRow,
  isActionColumnOnEnd,
}: Props) => {
  return (
    <div>
      <UITableHeader errors={errors} title={titleTable} child={headerActions} />
      <UIColumn
        isAllRowsSelected={data.length > 0 && selectRow?.length === data?.length}
        columns={columns}
        checkColumn={checkField}
        isOnViewMode={isOnViewMode}
        onSelectAll={onSelectRowAll}
        isActionColumnOnEnd={isActionColumnOnEnd}
      />
      <UIBody
        data={data}
        columns={columns}
        checkField={checkField}
        hasErrors={hasBodyErrors}
        isOnViewMode={isOnViewMode}
        actionColumn={actionColumn}
        selectedRow={selectRow}
        onSelectRow={onSelectRow}
        isActionColumnOnEnd={isActionColumnOnEnd}
      />
    </div>
  );
};

export default UITable;
